export const GOOGLE_API_KEY = 
// 'AIzaSyDZg6iJJMtwscCGlu5pRrohCD9K1Vqgdas'
'AIzaSyDg50OZZ_O8KwNg0aS3MIx2e0hdXprhEXU'
export const HOME_LATITUDE = -33.8688
export const HOME_LONGITUDE = 151.2093
